import { SingletonEditor } from "../ContentManager";

const ContactAdmin = () => (
  <div>
    <p className="mb-6 text-sm text-slate-500">Public contact details shown on the Contact page and footer. Email routing credentials and secrets are never shown or editable here.</p>
    <SingletonEditor type="contact" />
  </div>
);

export default ContactAdmin;
